import { render, staticRenderFns } from "./binFenCustomer-user-edit.vue?vue&type=template&id=13ccfdab&scoped=true"
import script from "./binFenCustomer-user-edit.vue?vue&type=script&lang=js"
export * from "./binFenCustomer-user-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ccfdab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13ccfdab')) {
      api.createRecord('13ccfdab', component.options)
    } else {
      api.reload('13ccfdab', component.options)
    }
    module.hot.accept("./binFenCustomer-user-edit.vue?vue&type=template&id=13ccfdab&scoped=true", function () {
      api.rerender('13ccfdab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/account-management/binFenCustomer-user-management/binFenCustomer-user-edit.vue"
export default component.exports